<div class="card mt-4" [ngClass]="{'border-danger shadow-lg border-3': !hasAnyContact() && !inCustomerDetailPage}">
  <div class="card-header font-weight-bold d-flex align-items-center justify-content-between" [ngClass]="{'bg-danger text-white': !hasAnyContact() && !inCustomerDetailPage}">
    <span>CONTACTS</span>
    @if (!hasAnyContact() && !inCustomerDetailPage) {
      <span class="ms-3 d-flex align-items-center">
        <i class="fa fa-exclamation-circle me-2" style="font-size:1.3rem;"></i>
        <span class="fw-bold" style="font-size:1.05rem;">Please add at least one contact to complete creation</span>
      </span>
    }
  </div>
  <div class="card-body">
    @if (alertInfo.show) {
      <ngb-alert [type]="alertInfo.type" (closed)="alertInfo.show = false">
        {{ alertInfo.message }}
      </ngb-alert>
    }

    @if (inCustomerDetailPage) {
      <div>
        @if (clientPersons && clientPersons.length) {
          <div class="company-owner-section mb-4">
            @if (!hideActionsColumn) {
              <div class="real-account-warning bg-warning-subtle p-3 mb-3">
                <div class="d-flex align-items-center">
                  <i class="fa fa-exclamation-triangle fa-2x me-3"></i>
                  <div>
                    <h5 class="mb-0">Real account warning</h5>
                    <p class="mb-0">!!! SEE THAT EMAIL ARE REAL, SO THE SYSTEM WILL SEND EMAIL TO THE REAL EMAIL ACCOUNT!!!</p>
                  </div>
                </div>
              </div>
            }
            <div class="mb-4">
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead class="bg-primary text-white">
                    <tr class="text-center">
                      <th class="text-white">Name</th>
                      <th class="text-white">Surname</th>
                      <th class="text-white">Email</th>
                      <th class="text-white">Phone</th>
                      <th class="text-white">MS Teams ID</th>
                      @if (!hideActionsColumn) {
                        <th class="text-white">Action</th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (contact of clientPersons; track contact) {
                      <tr>
                        <td>{{ contact.firstName }}</td>
                        <td>{{ contact.lastName }}</td>
                        <td>{{ contact.email }}</td>
                        <td>{{ contact.phone }}</td>
                        <td>{{ contact.msteamsId || 'not at the moment' }}</td>
                        @if (!hideActionsColumn) {
                          <td>
                            <div class="text-center">
                              <button type="button" class="btn btn-warning" (click)="updateAccountAndSendCredentials(contact)">
                                {{ getButtonText(contact) }}
                              </button>
                              @if (hasUser(contact)) {
                                <div class="small text-muted mt-1">
                                  Last update: {{ formatUpdateTime(contact.user?.updateTime) }}
                                </div>
                              }
                            </div>
                          </td>
                        }
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        }
        @if (!clientPersons || clientPersons.length === 0) {
          <div class="alert alert-info">
            No contacts available for this customer.
          </div>
        }
      </div>
    }


    @if (!inCustomerDetailPage) {
      <div>
        @for (role of getRoles(); track role) {
          <div class="mb-3">
            @if (getFormArrayByRole(role).controls.length) {
              <div>
                <h6 class="font-weight-bold">{{ role.replace('_', ' ') }}</h6>
                @for (contact of getFormArrayByRole(role).controls; track contact; let i = $index) {
                  <div class="d-flex align-items-center mb-2"
                    >
                    <div class="d-flex align-items-center flex-column col-switch">
                      <div>
                        <i class="fa fa-solid fa-user"
                        [ngbTooltip]="'Decision maker'"></i>
                      </div>
                      <div class="form-check form-switch" style="padding-left: 46px; padding-top: 12px;">
                        <input class="form-check-input" type="checkbox"
                          [formControl]="getSafeFormControl(contact, 'isDecisionMaker')"
                          (change)="onDecisionMakerChange(contact, $event)" [disabled]="readonlyContactsCustomer" />
                      </div>
                    </div>
                    <div class="d-flex flex-column pe-2 col">
                      @if (getSafeFormControl(contact, 'firstName')) {
                        <input-field type="text"
                          [inputFormControl]="getSafeFormControl(contact, 'firstName')" [readonly]="readonlyContactsCustomer"
                          label="Name" placeholder="firstName" />
                      }
                    </div>
                    <div class="d-flex flex-column pe-2 col">
                      @if (getSafeFormControl(contact, 'lastName')) {
                        <input-field type="text"
                          [inputFormControl]="getSafeFormControl(contact, 'lastName')" [readonly]="readonlyContactsCustomer"
                          label="Surname" placeholder="lastName" />
                      }
                    </div>
                    <div class="d-flex flex-column pe-2 col">
                      @if (getSafeFormControl(contact, 'email')) {
                        <input-field type="text"
                          [inputFormControl]="getSafeFormControl(contact, 'email')" [readonly]="readonlyContactsCustomer"
                          label="Email" placeholder="Email" />
                      }
                    </div>
                    <div class="d-flex flex-column pe-2 col">
                      @if (getSafeFormControl(contact, 'phone')) {
                        <input-field type="text"
                          [inputFormControl]="getSafeFormControl(contact, 'phone')" [readonly]="readonlyContactsCustomer"
                          label="Phone" placeholder="Phone" />
                      }
                    </div>
                    <div class="d-flex flex-column pe-2 col">
                      @if (getSafeFormControl(contact, 'msteamsId')) {
                        <input-field type="text"
                          [inputFormControl]="getSafeFormControl(contact, 'msteamsId')" [readonly]="readonlyContactsCustomer"
                          label="MS Teams ID" placeholder="MS Teams ID" />
                      }
                    </div>
                    <div class="mt-2">
                      @if (!readonlyContactsCustomer) {
                        <button class="btn btn-dark" style="padding: 8px 14px;"
                          [disabled]="getTotalContactCount() <= 1 || isContactDecisionMaker(contact)"
                          [ngbTooltip]="getTotalContactCount() <= 1 ? 'Cannot delete the last contact' : isContactDecisionMaker(contact) ? 'Cannot delete the Decision Maker contact' : ''"
                          (click)="confirmDelete(getFormArrayByRole(role), i, contact.value)">
                          <i class="fa fa-solid fa-user-times"></i>
                        </button>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
        <div class="d-flex justify-content-between">
          @for (role of this.manageRoles; track role) {
            <div>
              @if (!readonlyContactsCustomer) {
                <button class="btn btn-primary"
                  [disabled]="!isCreating && (clientPersons === undefined || clientPersons === null)" (click)="addNewContact(role.key)">
                  <i class="fa fa-solid fa-user-plus"></i> {{role.value}}
                </button>
              }
            </div>
          }
        </div>
        @if (!readonlyContactsCustomer) {
          <div class="text-center mt-4">
            <button type="button" [disabled]="!isCreating && (clientPersons === undefined || clientPersons === null)"
              class="btn btn-success px-4 py-2" (click)="submitForm()">
              Save
            </button>
          </div>
        }
      </div>
    }
  </div>
</div>